import React, { useState } from 'react';
import { Formik, Form as FormikForm, Field } from 'formik';
import { Form, Button, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import {
  selectFormAtividades,
  DropdownIndicator,
} from '~/Styles/reactSelectStyles';
import './styles.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importando o estilo
import { FaWindowClose, FaChevronDown } from 'react-icons/fa';
import * as Yup from 'yup';
import FormularioTarefas from '../FormularioTarefas';

const Email = ({
  onSubmit,
  initialValues,
  salvandoDados,
  closeModal,
  exibirTarefa,
  readOnly,
  hiddenSubmit,
}) => {
  const mensagemPadraoOptions = [
    { value: '0', label: 'Vazio' },
    { value: '1', label: 'Mensagem de Boas-vindas' },
    { value: '2', label: 'Lembrete de Reunião' },
    { value: '3', label: 'Agradecimento' },
  ];
  const [exibirBlocoTarefa, setExibirBlocoTarefa] = useState(exibirTarefa);
  const [tarefaIncluida, setTarefaIncluida] = useState(false);
  const [tarefaValues, setTarefaValues] = useState({
    descricao: '',
    data: '',
    prioridade: '',
    situacao: '',
    tipoResponsavel: '',
    responsavel: '',
    lembreteEmail: '',
  });

  const handleSubmit = values => {
    if (tarefaIncluida) {
      onSubmit({ ...values, tarefaInternaValues: tarefaValues });
      return;
    }
    onSubmit(values);
  };

  const handleSubmitTarefa = values => {
    setTarefaValues(values);
    setTarefaIncluida(true);
  };

  const closeBlocoTarefa = () => {
    setExibirBlocoTarefa(false);
    setTarefaIncluida(false);
    setTarefaValues('');
  };

  const validationSchema = Yup.object().shape({
    mensagemPadrao: Yup.string().required('Selecione uma mensagem padrão.'),

    assunto: Yup.string()
      .required('O campo assunto é obrigatório.')
      .max(255, 'O assunto deve ter no máximo 255 caracteres.'),

    descricao: Yup.string()
      .required(
        exibirBlocoTarefa
          ? 'Preencha os campos do formulário de tarefas'
          : `A descrição é obrigatória.`
      )
      .test(
        'conteudo-vazio',
        'A descrição não pode estar vazia.',
        value => !!value && value.replace(/<(.|\n)*?>/g, '').trim().length > 0
      ),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => {
        handleSubmit(values);
      }}
    >
      {({ values, setFieldValue, handleSubmit, errors, touched }) => (
        <Form as={FormikForm} onSubmit={handleSubmit} className="p-2">
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <label className="label-form-email">Mensagem Padrão</label>
                <Select
                  options={mensagemPadraoOptions}
                  name="mensagemPadrao"
                  onChange={option =>
                    setFieldValue('mensagemPadrao', option.value)
                  }
                  value={
                    mensagemPadraoOptions.find(
                      opt => opt.value === values.mensagemPadrao
                    ) || null
                  }
                  className="react-select"
                  styles={selectFormAtividades}
                  components={{ DropdownIndicator }}
                  isSearchable={false}
                  isDisabled={readOnly}
                  isInvalid={errors.mensagemPadrao}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="assunto">
                <Form.Label className="label-form-email">Assunto</Form.Label>
                <Field
                  as={Form.Control}
                  name="assunto"
                  type="text"
                  className="form-control"
                  isInvalid={touched.assunto && errors.assunto}
                  disabled={readOnly}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Form.Group
              className="mb-3 p-2 w-100"
              controlId="descricao"
              isInvalid={touched.descricao && errors.descricao}
            >
              <Form.Label>Descrição</Form.Label>
              <div>
                <ReactQuill
                  value={values.descricao}
                  onChange={value => setFieldValue('descricao', value)}
                  theme="snow"
                  readOnly={readOnly}
                />
              </div>
            </Form.Group>

            <Form.Control.Feedback type="invalid" className=" ml-2 d-block">
              {(Object.keys(errors).length > 0 ||
                Object.keys(touched).length === 0) &&
                !hiddenSubmit && <>Preencha todos os campos</>}
            </Form.Control.Feedback>
          </Row>
          {!hiddenSubmit && (
            <>
              <div className="mb-3">
                <div
                  className="d-flex align-items-center justify-content-between p-3 rounded"
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                  onClick={() => setExibirBlocoTarefa(!exibirBlocoTarefa)}
                >
                  <div className="d-flex align-items-center">
                    <span
                      style={{
                        color: '#495057',
                        fontWeight: '500',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                      }}
                    >
                      Vincular a uma tarefa
                    </span>
                  </div>
                  <div
                    style={{
                      transform: exibirBlocoTarefa
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                      transition: 'transform 0.3s ease',
                    }}
                  >
                    <FaChevronDown
                      style={{ color: '#6c757d', fontSize: '12px' }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    maxHeight: exibirBlocoTarefa ? '1000px' : '0px',
                    overflow: exibirBlocoTarefa ? 'visible' : 'hidden',
                    transition: 'max-height 0.3s ease-in-out',
                    backgroundColor: '#fff',
                    border: exibirBlocoTarefa ? '1px solid #e9ecef' : 'none',
                    borderTop: 'none',
                    borderRadius: '0 0 0.375rem 0.375rem',
                    position: 'relative',
                    zIndex: 99998,
                  }}
                >
                  {exibirBlocoTarefa && (
                    <div
                      className="p-3"
                      style={{ position: 'relative', zIndex: 99999 }}
                    >
                      <FormularioTarefas
                        onSubmit={handleSubmitTarefa}
                        initialValues={tarefaValues}
                        salvandoDados={salvandoDados}
                        closeModal={closeBlocoTarefa}
                        modoInternoDaAnotacao={{
                          exibir: exibirBlocoTarefa,
                          incluido: tarefaIncluida,
                        }}
                        modoEdicao={true}
                        readOnly={tarefaIncluida}
                      />
                    </div>
                  )}
                </div>
              </div>

              {exibirBlocoTarefa && !tarefaIncluida && (
                <div className="text-danger small my-2">
                  Preencha os campos do formulário de Tarefa
                </div>
              )}
            </>
          )}

          {!hiddenSubmit && (
            <>
              <hr className="my-4"></hr>
              <div className="d-flex justify-content-end">
                <Button
                  type="submit"
                  className="btn-light-color"
                  size="sm"
                  disabled={
                    salvandoDados ||
                    Object.keys(errors).length > 0 ||
                    Object.keys(touched).length === 0 ||
                    (exibirBlocoTarefa && !tarefaIncluida) ||
                    readOnly
                  }
                >
                  Enviar Email
                </Button>
                <Button
                  variant="light"
                  size="sm"
                  type="button"
                  className="d-inline-flex align-items-center ml-2"
                  onClick={() => {
                    closeModal();
                  }}
                  disabled={salvandoDados}
                >
                  <FaWindowClose />
                  <span className="ml-2 d-xs-none">Fechar</span>
                </Button>
              </div>
            </>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default Email;
